export const BROWSE_PAGE_REGEX =
  /\/(places|salons|orte|establecimientos|saloni|salonai|estabelecimentos|katasthmata)(?:$|\/.*)/;
export const HOME_PAGE_REGEX = /^\/$/;
export const VENUE_PAGE_REGEX =
  /\/(place|ort|salon|establecimiento|salone|salonas|estabelecimento|katasthma)(\/|$)/;
